import { Spinner } from "@/components/ui/spinner";
import { useEffect, useMemo } from "react";
import { AuthLandingPage } from "@/components/auth/AuthLandingPage";
import { normalizeAuthCallbackUrl, readFirstQueryValue } from "@/lib/auth-redirect";
import { useAuthSession } from "@/lib/auth/auth-provider";
import { useAppRouter } from "@/lib/navigation";

type HomePageProps = {
  searchParams: URLSearchParams;
};

export default function HomePage({ searchParams }: HomePageProps) {
  const { status } = useAuthSession();
  const router = useAppRouter();
  const callbackUrl = normalizeAuthCallbackUrl(searchParams.get("callbackUrl") ?? undefined);
  const authError = readFirstQueryValue(searchParams.get("error") ?? undefined);
  const loggedOut = searchParams.get("loggedOut") === "1";
  const stableCallbackUrl = useMemo(() => callbackUrl, [callbackUrl]);

  useEffect(() => {
    if (status === "authenticated") router.replace(stableCallbackUrl);
  }, [router, stableCallbackUrl, status]);

  if (status === "loading" || status === "authenticated") return <HomePageFallback />;

  return (
    <AuthLandingPage
      authError={authError}
      callbackUrl={callbackUrl}
      loggedOut={loggedOut}
    />
  );
}

function HomePageFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="text-center">
        <Spinner size={64} className="text-neutral-900 mx-auto" />
        <p className="mt-2 text-gray-600">Preparando autenticacion...</p>
      </div>
    </div>
  );
}
